// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#svg-send-photo[data-v-698ce276] {\n    width: 25px;\n    height: 25px;\n}\n", ""]);
// Exports
module.exports = exports;
